module.exports = __webpack_public_path__ + "assets/img/menu-arrow-down.3d407491.svg";